import { DEBOUNCE_DELAY } from '@autone/utils';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

const useDebouncedValue = <T>({
  value,
  defaultValue,
  delay = DEBOUNCE_DELAY,
}: {
  value: T;
  defaultValue: T;
  delay?: number;
}) => {
  const [debouncedValue, setDebouncedValue] = useState(defaultValue);
  const debounceFunction = debounce(() => {
    setDebouncedValue(value);
  }, delay);

  useEffect(() => {
    debounceFunction();
    return () => debounceFunction.cancel();
    // stringify here to stabilise the debounce function
  }, [JSON.stringify(value)]);

  return debouncedValue;
};

export default useDebouncedValue;
